exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".confirmButton__BVI-module___2Kkas {\n    background-color: #e7faf5;\n    color: #0acf97;\n    box-shadow: none;\n    margin: 0;\n    border-radius: 0.375rem;\n    padding: 8px 12px;\n    font-weight: 400;\n  }\n  \n  .confirmButton__BVI-module___2Kkas:hover {\n    background-color: #0acf97;\n    color: #fff;\n    box-shadow: none;\n  }\n\n@media (max-width: 762px) {\n    .cellButtonContainer__BVI-module___3pbpN {\n      margin-top: 26px;\n    }\n    .cell__BVI-module___oek1w {\n      padding-bottom: 12px;\n    }\n   \n  }", ""]);

// Exports
exports.locals = {
	"confirmButton": "confirmButton__BVI-module___2Kkas",
	"cellButtonContainer": "cellButtonContainer__BVI-module___3pbpN",
	"cell": "cell__BVI-module___oek1w"
};